import { render, staticRenderFns } from "./CheckResult.vue?vue&type=template&id=204520b2&scoped=true&"
import script from "./CheckResult.vue?vue&type=script&lang=js&"
export * from "./CheckResult.vue?vue&type=script&lang=js&"
import style0 from "./CheckResult.vue?vue&type=style&index=0&id=204520b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204520b2",
  null
  
)

export default component.exports